const BankTransactionStatusEnum = {
  NOT_PROCESS: 0,
  SUCCESS: 1,
  INVALID_ORDER: 2,
  INVALID_AMOUNT: 3,
  INVALID_APPROVE_ORDER: 4
}
export default BankTransactionStatusEnum
